import moment from 'moment';

export default {
    entityName: "returned",
    upsert: "full",
    filterStorage: {},
    pagination: {
        itemsPerPage: 10,
        page: 1,
        sortBy: "request_date",
        descending: true
    },
    fields: [
        {
            text: 'Insert Date',
            value: 'request_date',
            table: {
                filter: true
            },
            //issue 316 - modifica date da-a , aggiunto placeholderx
            filtertofrom: true,
            'type': 'date', //issue 257 services cambiato datetime con date
            //visible: false,
            //issue 316 - modifica date da-a , aggiunto placeholderx
            render: item => moment(item.request_date).format('YYYY-MM-DD'),
        },
        {
              text: 'Requested Date',
              value: 'status_requested_date',
              render: item => item.status_requested_date ? moment(item.status_requested_date).format('YYYY-MM-DD'):null,
              filtertofrom: true,
              'type': 'datetime',
              readonly: (item,state)=>  !(state.user.role === 'Administrator' || state.user.role === 'EMN User'),
              visible: (item,state)=>  (state.user.role === 'Administrator' || state.user.role === 'EMN User') && (item.status === 'REQUESTED' || item.status === 'CANCELED' || item.status === 'CONFIRMED'),
              validators: [
                    (field, value, item) => {
                    if (!item.canceling && !value) {
                        return 'Requested Date is required'
                    }
                    if(value<item.request_date){
                        return 'Requested Date must be greater than or equal to the Insert Date.'
                    }
                    return true
                    },
                ]
        },
        {
              text: 'Canceled Date',
              value: 'status_canceled_date',
              render: item => item.status_canceled_date ? moment(item.status_canceled_date).format('YYYY-MM-DD'):null,
              filtertofrom: true,
              'type': 'datetime',
              readonly: (item,state)=>  !(state.user.role === 'Administrator' || state.user.role === 'EMN User'),
              visible: (item,state)=>  (state.user.role === 'Administrator' || state.user.role === 'EMN User') && item.status === 'CANCELED',
              validators: [
                    (field, value, item) => {
                    if (!item.canceling && !value) {
                        return 'Canceled Date is required'
                    }
                    if(value<item.request_date){
                        return 'Canceled Date must be greater than or equal to the Insert Date.'
                    }
                    if(value<item.status_requested_date){
                        return 'Canceled Date must be greater than or equal to the Requested Date.'
                    }
                    if(value<item.status_confirmed_date){
                        return 'Canceled Date must be greater than or equal to the Confirmed Date.'
                    }
                    return true
                    },
                ]
        },
        {
              text: 'Confirmed Date',
              value: 'status_confirmed_date',
              render: item => item.status_confirmed_date ? moment(item.status_confirmed_date).format('YYYY-MM-DD'):null,
              filtertofrom: true,
              'type': 'datetime',
              readonly: (item,state)=>  !(state.user.role === 'Administrator' || state.user.role === 'EMN User'),
              visible: (item,state)=>  (state.user.role === 'Administrator' || state.user.role === 'EMN User') && item.status === 'CONFIRMED',
              validators: [
                    (field, value, item) => {
                    if (!item.canceling && !value) {
                        return 'Confirmed Date is required'
                    }
                    if(value<item.request_date){
                        return 'Confirmed Date must be greater than or equal to the Insert Date.'
                    }
                    if(value<item.status_requested_date){
                        return 'Confirmed Date must be greater than or equal to the Requested Date.'
                    }
                    return true
                    },
                ]
        },
        {
            text: 'Package ready from',
            value: 'box',
            small: true,
            type: 'datetime',
            min: true,
            visible: item => item.status === 'INIT',
            validators: [
                'required',
                (field, value) => moment().isSameOrBefore(moment(value), 'day') || `Can't be in the past`
            ]
        },
        {
            value: "protocol_id",
            type: 'autocomplete',
            text: "Protocol",
            table: {
                sortable: true,
                filter: true
            },
            title: "name",
            small: true,
            validators: ['required'],
            visible: false
        },
        {
            value: "site.city",
            text: "Site",
            render: ({ site }) => site && `${site.city} - ${site.name}`,
            filter: (item, search) => {
                if (search) {
                    return [
                        { 'site.name': `%${search}%` },
                        { 'site.city': `%${search}%` },
                        { 'site.code': `%${search}%` }
                    ];
                }
            },
            table: {
                sortable: true,
                filter: true
            },
            readonly: true,
            visible: (item, state) => 
                ['Administrator', 'EMN User', 'Monitor'].includes(state.user.role),
        },
        {
            value: "_pdf",
            text: "Return documentation",
            type: 'file',
            readonly: false,
            visible: (item, state) => 
                item.status !== 'CANCELED' && 
                ['Administrator', 'EMN User'].includes(state.user.role),
            validators: [],
        },
        {
            text: 'Status',
            value: 'status',
            type: 'list',
            list: ['INIT', 'REQUESTED', 'CONFIRMED', 'CANCELED'],
            table: {
                filter: true
            },
            visible: false
        },
        {
            full: true,
            value: 'note',
            text: 'Note',
            visible: item => !!item.note,
            type: 'textarea',
        },
        {
            value: 'returned_drugs.name',
            text: 'Drugs',
            id: 'id',
            filter: (item, search) => search && [{ 'returned_drugs.name': `%${search}%` }],
            subtitle: item => `${item.dose}${item.measure_unit} - ${item.protocol.name}`,
            type: 'autocomplete',
            table: {
                filter: true,
            },
            render: item => 
                item.returned_drugs && item.returned_drugs.reduce((drugs, drug, idx) => 
                    drugs + `${drug.name}(${drug.dose + drug.measure_unit}, ${item.drugs[idx] && (item.drugs[idx].n_pieces + '/' + item.drugs[idx].n_partially)}) `, ''),
            visible: false
        }
    ],
    actions: ['upsert', 'audit']
};
